import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconTurnOffComponent } from "./med-icon-turn-off.component";

@NgModule({
  declarations: [
    MedIconTurnOffComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconTurnOffComponent,
  ],
})
export class MedIconTurnOffModule { }
